import React from 'react';

const EmptyStateMessage: React.FC = () => {
  return (
    <div className="frontpage-title text-muted rounded rounded-lg bg-light text-center p-4">
      <span className="lead">Add a timezone by clicking 'Add Timezone' below.</span>
    </div>
  );
};

export default EmptyStateMessage;
